import { IpsDeniedView as IpsDenied } from './IpsDenied';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";
import { actionSetListNotification } from '@/redux/actions';

// const mapStateToProps = (state) => ({...state})

const mapStateToProps = ({ NotificationReducer, TranslateReducer }) => ({
   $store: {
      NotificationReducer,
      TranslateReducer
   },
});
const mapDispatchToProps = (dispatch) => ({
   $action: bindActionCreators(
      {
         actionSetListNotification: actionSetListNotification
      },
      dispatch
   ),
});

//export default connect(mapStateToProps)(withRouter(Home));

//export const HomeView: any = connect(mapStateToProps,NotificationsAction)(withRouter(Home));

export const IpsDeniedView: any = compose(
   withRouter,
   connect(mapStateToProps, mapDispatchToProps)
)(IpsDenied);
